import { Price } from './Price';
import styles from './PriceBox.module.scss';
import { List } from '../../dataProvider';
type PriceBoxProps = {
  offer: List;
  entryCount?: number;
  onShowEntries?: (list: List) => void;
};
export const PriceBox = ({
  offer,
  entryCount,
  onShowEntries,
}: PriceBoxProps) => {
  return (
    <div className={styles.container}>
      <Price
        offer={offer}
        entryCount={entryCount}
        onShowEntries={onShowEntries}
      />
    </div>
  );
};
